import React, { useState } from "react";
import { SearchProviderFilterModalProps } from "./SearchProvider.types";
import Modal from "react-modal";
import CloseIcon from "../Components/CloseIcon";
import { filterNameFromString } from "./SearchProviderForm";

const customStyles = {
  content: {
    left: "50%",
    right: "auto",
    bottom: "auto",
    backgroundColor: "white",
    maxWidth: "764px",
    maxHeight: "531px",
    height: "calc(100vh - 200px)",
    width: "calc(100vw - 40px)",
    borderRadius: "4px",
    position: "absolute",
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
    transform: "translate(-50%, -50%)",
    justifyContent: "space-between",
    flexDirection: "column",
    display: "flex",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
};

Modal.setAppElement("#search-providers");

const SearchProviderFilterModal: React.FC<SearchProviderFilterModalProps> = (
  props
) => {
  const {
    isOpen,
    closeModal,
    filters,
    totalProviders,
    handleFilterChange,
    selectedFilters,
  } = props;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={customStyles}
      closeTimeoutMS={600}
      className="moj-modal mjb"
      contentLabel="Update filters"
    >
      <div className="moj-modal__content">
        <h2 className="h4">Apply filters</h2>

        {filters &&
          filters.map((filter) => {
            let name = filter.name;

            const selectedValue =
              selectedFilters && selectedFilters.find((f) => f.name === name);

            const hasNoFilterSelected =
              selectedValue === undefined || !selectedValue.value.length;

            return (
              <div className="moj-modal__filter" key={filter.label}>
                <label>{filter.label}</label>
                <div className="moj-modal__filter__options">
                  <div className="moj-modal__filter__option">
                    <input
                      type="checkbox"
                      checked={
                        hasNoFilterSelected || selectedValue.value === "all"
                      }
                      name={name}
                      id={`${name}-all`}
                      value="all"
                      onChange={() => {
                        handleFilterChange({
                          target: {
                            name,
                            value: "all",
                            checked: hasNoFilterSelected,
                          },
                        } as React.ChangeEvent<HTMLInputElement>);
                      }}
                    />
                    <label htmlFor={`${name}-all`}>All</label>
                  </div>

                  {filter.options &&
                    filter.options.map((option) => {
                      const checkedOption = selectedValue?.value === option;

                      // replace any non A-Z characters with a hyphen and make lowercase
                      const niceId = filterNameFromString(`${name}-${option}`);

                      return (
                        <div key={option} className="moj-modal__filter__option">
                          <input
                            type="checkbox"
                            id={niceId}
                            name={name}
                            value={option}
                            onChange={handleFilterChange}
                            checked={checkedOption}
                          />
                          <label htmlFor={niceId}>
                            {option} <CloseIcon />
                          </label>
                        </div>
                      );
                    })}
                </div>
              </div>
            );
          })}
      </div>

      <div className="moj-modal__footer">
        <button
          type="button"
          className="moj-modal__footer-button"
          onClick={closeModal}
        >
          Show {totalProviders} {totalProviders === 1 ? "result" : "results"}
        </button>

        <button
          type="reset"
          className="moj-modal__footer-button--plain"
          onClick={() => {
            closeModal();
          }}
        >
          Clear
        </button>
      </div>
    </Modal>
  );
};

export default SearchProviderFilterModal;
